import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { PlayerProvider, usePlayer } from "@/contexts/PlayerContext";
import { AlarmProvider } from "@/contexts/AlarmContext";
import Navbar from "@/components/Navbar";
import AppStatus from "@/components/AppStatus";
import ErrorBoundary from "@/components/ErrorBoundary";
import BottomNav from "@/components/BottomNav";
import PlayerBar from "@/components/PlayerBar";
import YTAudioController from "@/components/YTAudioController";
import AuthCallback from "@/components/AuthCallback";
import NowPlaying from "@/components/NowPlaying";
import Home from "@/pages/Home";
import Radios from "@/pages/Radios";
import Videos from "@/pages/Videos";
import Music from "@/pages/Music";
import Library from "@/pages/Library";
import Login from "@/pages/Login";
import Discover from "@/pages/Discover";
import SharedPlaylist from "@/pages/SharedPlaylist";

function ExpandedOverlay() {
  const { expanded } = usePlayer();
  if (!expanded) return null;
  return <NowPlaying />;
}

function MobileChrome() {
  const { current } = usePlayer();
  return <BottomNav hasPlayer={Boolean(current)} />;
}

function AppShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col">
      <AppStatus />
      <Navbar />
      <main className="flex-1 pb-[160px] md:pb-24">
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/radios" element={<Radios />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/music" element={<Music />} />
          <Route path="/library" element={<Library />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/login" element={<Login />} />
          <Route path="/share/playlist/:token" element={<SharedPlaylist />} />
          <Route path="*" element={<Home />} />
        </Routes>
        </ErrorBoundary>
      </main>
      <PlayerBar />
      <YTAudioController />
      <MobileChrome />
      <ExpandedOverlay />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(7, 13, 24, 0.96)",
            color: "#F8FAFC",
            border: "1px solid rgba(9, 231, 255, 0.28)",
            borderRadius: "18px",
            fontFamily: "'Inter', sans-serif",
            boxShadow: "0 22px 60px rgba(0,0,0,0.34)",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <AlarmProvider>
              <AppShell />
            </AlarmProvider>
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
